import { Pipe, PipeTransform } from '@angular/core';
import { EmailTriggers } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'emailTriggerDisplay',
})
export class EmailTriggerDisplayPipe implements PipeTransform {
  transform(value: EmailTriggers): string {
    return emailTriggerDisplayTransform(value);
  }
}

export function emailTriggerDisplayTransform(value: EmailTriggers) {
  return CoreNiceLabelUtils.emailTrigger(value);
}
